import axiosInstance from "../../config/Axios";

export const getDukas = async ({ page = 1, limit = 10, ...filters } = {}) => {
    try {
        const offset = (page - 1) * limit;
        const response = await axiosInstance({
            method: 'get',
            url: '/api/duka/dukas/',
            params: {
                limit,
                offset,
                ...filters
            }
        });
        return {
            data: response.data.results,
            total: response.data.count,
            next: response.data.next,
            previous: response.data.previous
        };
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getDukaById = async (id) => {
    try {
        return await axiosInstance({
            method: 'get',
            url: `/api/duka/dukas/${id}/`,
        });
    } catch (error) {
        return Promise.reject(error);
    }
};

export const createDuka = async (dukaData) => {
    const transformedData = { 
        ...dukaData,
        // duka_coordinators: dukaData.dukaCoordinators
        
    };
    console.log(transformedData);
    
    try {
        return await axiosInstance({
            method: 'post',
            url: '/api/duka/dukas/',
            data: transformedData
        });
    } catch (error) {
        return Promise.reject(error);
    }
};

export const updateDuka = async (id, dukaData) => {
    try {
        return await axiosInstance({
            method: 'put',
            url: `/api/duka/dukas/${id}/`,
            data: dukaData
        });
    } catch (error) {
        return Promise.reject(error);
    }
};

export const deleteDuka = async (id) => {
    if (!id) {
        return Promise.reject(new Error('Duka ID is required'));
    }
    try {
        const response = await axiosInstance({
            method: 'delete',
            url: `/api/duka/dukas/${id}/`,
        });
        return response;
    } catch (error) {
        console.error('Delete API Error:', error?.response?.data || error.message);
        return Promise.reject(error);
    }
};

export const bulkUploadDukaMapping = async (file) => {
    try {
        const formData = new FormData();
        formData.append("file", file);
        return await axiosInstance({
            method: "post",
            url: "api/duka/duka-mapping/bulk-upload/",
            data: formData,
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    } catch(error){
        return Promise.reject(error);
    }
}

export const dukaElements = async (elem) => {
    try {
        return await axiosInstance({
            method: 'get',
            url: `/api/duka/element-list/${elem}/`,
        });
    } catch (error) {
        return Promise.reject(error);
    }
}